/**
 * Platform racquet sport catalogue identifiers and display labels.
 * Icons, colours, and equipment copy belong in web/mobile packages only.
 */

export const RACQUET_SPORT_IDS = [
  'tennis',
  'pickleball',
  'padel',
  'badminton',
  'squash',
  'other',
] as const;

export type RacquetSportId = (typeof RACQUET_SPORT_IDS)[number];

export const DEFAULT_RACQUET_SPORT_ID: RacquetSportId = 'tennis';

/** Human-readable labels for UI and emails (neutral, not federation-specific). */
export const RACQUET_SPORT_LABELS: Record<RacquetSportId, string> = {
  tennis: 'Tennis',
  pickleball: 'Pickleball',
  padel: 'Padel',
  badminton: 'Badminton',
  squash: 'Squash',
  other: 'Other',
};

/** Facility terminology per sport (for owner UI copy). */
export const RACQUET_SPORT_FACILITY_LABELS: Record<RacquetSportId, string> = {
  tennis: 'Court',
  pickleball: 'Court',
  padel: 'Court',
  badminton: 'Court',
  squash: 'Court',
  other: 'Court',
};

export function isRacquetSportId(value: string): value is RacquetSportId {
  return (RACQUET_SPORT_IDS as readonly string[]).includes(value);
}

export function racquetSportLabel(sportId: RacquetSportId, customOtherLabel?: string | null): string {
  if (sportId === 'other' && customOtherLabel?.trim()) {
    return customOtherLabel.trim();
  }
  return RACQUET_SPORT_LABELS[sportId];
}
